import Configs from '@/Configs';

export const DAYS_OFF_CONFIG = {
  name: 'Time-off',
  icon: 'Calendar',
  library: 'phosphor',
  routing: {
    self: {
      path: '/timeoff/home',
      securityLevel: [Configs.securityLevelIC],
    },
    team: {
      path: '/timeoff/team/',
      securityLevel: [Configs.securityLevelManager, Configs.securityLevelHR],
    },
    hr: {
      path: '/timeoff/hr/',
      securityLevel: [Configs.securityLevelHR],
    },
    request: {
      path: '/timeoff/request',
      securityLevel: [Configs.securityLevelIC],
    },
    requestWithParams: {
      path: '/timeoff/request/:encryptedParams',
      securityLevel: [Configs.securityLevelIC],
    },
    award: {
      path: '/timeoff/team/award/:encryptedParams',
      securityLevel: [Configs.securityLevelManager, Configs.securityLevelHR],
    },
    teamWithParams: {
      path: '/timeoff/team/:encryptedParams',
      securityLevel: [Configs.securityLevelManager, Configs.securityLevelHR],
    },
    teamDetailed: {
      path: '/timeoff/team/detailed/',
      securityLevel: [Configs.securityLevelManager, Configs.securityLevelHR],
    },
  }
};